module.exports = __webpack_public_path__ + "static/Q3Answer4_Chocolate_CharisseKenion-337543e036e31dcec206df896a6fbbcc.jpg";